import { MINUTES_OPTIONS } from './constants';
import { BlockedTimes, ParsedTime } from './types';

const MAX_HOURS = 23;
const MAX_MINUTES = 59;
const MAX_TIME_DIGITS = 4;
const TIME_PATTERN = /^(\d{2}):(\d{2})$/;

export const padTime = (value: number) => String(value).padStart(2, '0');

export const formatTimeValue = (hours: number, minutes: number) =>
  `${padTime(hours)}:${padTime(minutes)}`;

export const parseTimeValue = (value: string): ParsedTime => {
  const match = TIME_PATTERN.exec(value);
  if (!match) return {};

  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (hours > MAX_HOURS || minutes > MAX_MINUTES) return {};

  return { hours, minutes };
};

export const maskTimeInput = (raw: string) => {
  const digits = raw.replace(/\D/g, '').slice(0, MAX_TIME_DIGITS);
  if (digits.length <= 2) return digits;

  return `${digits.slice(0, 2)}:${digits.slice(2)}`;
};

export const normalizeTimeDraft = (draft: string) => {
  const [rawHours, rawMinutes] = draft.split(':');
  if (!rawHours || !rawMinutes) return '';

  return formatTimeValue(Number(rawHours), Number(rawMinutes));
};

export const isValidTime = (value: string, blockedTimes: BlockedTimes = {}) => {
  const { hours, minutes } = parseTimeValue(value);
  if (hours === undefined || minutes === undefined) return false;

  return !blockedTimes[hours]?.includes(minutes);
};

export const isHourDisabled = (
  hour: number,
  blockedTimes: BlockedTimes = {},
  selectedMinute?: number,
) => {
  const blockedMinutes = blockedTimes[hour];
  if (!blockedMinutes) return false;
  if (selectedMinute !== undefined)
    return blockedMinutes.includes(selectedMinute);

  return MINUTES_OPTIONS.every(minute => blockedMinutes.includes(minute));
};

export const isMinuteDisabled = (
  minute: number,
  blockedTimes: BlockedTimes = {},
  selectedHour?: number,
) => {
  if (selectedHour === undefined) return false;

  return Boolean(blockedTimes[selectedHour]?.includes(minute));
};
